export var routes = {
    INDEX: '/pairs',
    LOGIN: '/',
    PAIR_LIST: '/pairs',
    PAIR_CREATE: '/pairs/create',
    PAIR_SHOW: '/pairs/:id',
    PAIR_EDIT: '/pairs/:id/edit',
    ACCOUNTS: '/accounts',
    ACCOUNTS_CREATE: '/accounts/create',
    ACCOUNTS_ORDERS: '/accounts/orders/:id',
    ACCOUNTS_ORDERS_CANCEL: '/accounts/orders/cancel/:orderId',
    ACCOUNTS_SHOW: '/accounts/:id',
    ACCOUNTS_EDIT: '/accounts/:id/edit',
    BROKER_LIST: '/brokers',
    BROKER_CREATE: '/brokers/create',
    PROCESSES: '/processes',
    ALGORITHM: '/algorithms/:name',
    ALGORITHM_CREATE: '/algorithms/:name/create',
    ALGORITHM_EDIT: '/algorithms/:name/:id/edit',
    ALGORITHM_SHOW: '/algorithms/:name/:id',
    ALGORITHMS: '/algorithms',
    ALGORITHMS_CREATE: '/algorithms/create',
    PROCESSES_CREATE: '/processes/create',
    REPORTS: '/reports/:id',
    REPORTS_TEMPLATES: '/reports/:id/templates',
    REPORTS_TEMPLATES_CREATE: '/reports/:id/templates/create',
    REPORTS_TEMPLATES_EDIT: '/reports/:id/templates/edit/:templateId',
    REPORTS_DIAGRAM: '/reportsDiagram',
    REPORTS_TEMPLATE: '/reports/:id',
    BALANCE_CURRENCY_LIST: '/balanceCurrency',
    BALANCE_CURRENCY_CREATE: '/balanceCurrency/create',
    USER_LIST: '/users',
    USER_CREATE: '/users/create',
    USER_EDIT: '/users/:id/edit',
    USER_SHOW: '/users/:id',
    SETTINGS: '/settings',
    CLIENTS: '/clients',
    CLIENTS_CREATE: '/clients/create',
    CLIENTS_SHOW: '/clients/:id',
    CLIENTS_EDIT: '/clients/:id/edit',
    ROLES_ACCESS: '/roleAccess',
    ROLES_ACCESS_EDIT: '/roleAccess/:id/edit',
    DASHBOARD_LIST: '/dashboard',
    POSITION_LIST: '/position',
    ALGORITHM_LIST: '/algorithm',
    RISK: '/risk',
    LOGS: '/logs'
};
